var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMSupervisores(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#0b5c96;}.cls-3{fill:none;}.cls-4{fill:#2eccb6;}.cls-5{fill:#329be6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_supervisores"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.16,30.29A11.49,11.49,0,1,0,16,44.5a11.34,11.34,0,0,0,3.05-.42c0-.36-.05-.72-.05-1.08A14,14,0,0,1,27.16,30.29Zm-17.08.64A5.94,5.94,0,1,1,16,36.87,5.95,5.95,0,0,1,10.08,30.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,27.5a3.44,3.44,0,1,0,3.43,3.43A3.44,3.44,0,0,0,16,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,37.5a3.44,3.44,0,1,0,3.43,3.43A3.44,3.44,0,0,0,33,37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,31.5A11.5,11.5,0,1,0,44.5,43,11.51,11.51,0,0,0,33,31.5Zm0,15.37A5.94,5.94,0,1,1,39,40.93,5.95,5.95,0,0,1,33,46.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,27.5a3.44,3.44,0,1,0,3.43,3.43A3.44,3.44,0,0,0,50,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,21.5a11.5,11.5,0,0,0-11.16,8.79A14,14,0,0,1,47,43c0,.36,0,.72,0,1.07a11,11,0,0,0,3,.43,11.5,11.5,0,0,0,0-23Zm0,15.37A5.94,5.94,0,1,1,56,30.93,5.95,5.95,0,0,1,50,36.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,35A5.94,5.94,0,1,0,39,40.93,5.95,5.95,0,0,0,33,35Zm0,9.37a3.44,3.44,0,1,1,3.43-3.44A3.44,3.44,0,0,1,33,44.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,30.93A5.94,5.94,0,1,0,16,36.87,5.94,5.94,0,0,0,22,30.93ZM16,34.37a3.44,3.44,0,1,1,3.43-3.44A3.44,3.44,0,0,1,16,34.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,25A5.94,5.94,0,1,0,56,30.93,5.95,5.95,0,0,0,50,25Zm0,9.37a3.44,3.44,0,1,1,3.43-3.44A3.44,3.44,0,0,1,50,34.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.29,41.51l.15-.07L6.63,39.63A11.89,11.89,0,0,0,8.29,41.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.59,26.41l2.82-2.82A11.45,11.45,0,0,0,6.59,26.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.59,23.59l2.82,2.82A11.45,11.45,0,0,0,56.59,23.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.72,41.5a11.7,11.7,0,0,0,1.65-1.87l-1.79,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2.19,30.81.28,32.72a.4.4,0,0,0,0,.56l1.91,1.91a12.72,12.72,0,0,1,0-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.53,46.55a14,14,0,0,1-27.06,0A13.7,13.7,0,0,1,16,47a14.38,14.38,0,0,1-2.19-.19L32.72,65.72a.4.4,0,0,0,.56,0L52.19,46.81A14.38,14.38,0,0,1,50,47,13.7,13.7,0,0,1,46.53,46.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.72,32.72l-1.91-1.91a12.72,12.72,0,0,1,0,4.38l1.91-1.91A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.41,26.41l4.4,4.4A14,14,0,0,0,52.19,19.19l4.4,4.4A11.45,11.45,0,0,1,59.41,26.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.72,41.5l-.14-.08-5.39,5.39A14,14,0,0,0,63.81,35.19l-4.44,4.44A11.7,11.7,0,0,1,57.72,41.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M9.41,23.59l4.4-4.4A14,14,0,0,0,2.19,30.81l4.4-4.4A11.45,11.45,0,0,1,9.41,23.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.29,41.51a11.89,11.89,0,0,1-1.66-1.88L2.19,35.19A14,14,0,0,0,13.81,46.81L8.44,41.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.81,30.81l-4.4-4.4a11.41,11.41,0,0,1,0,13.22l4.44-4.44a12.72,12.72,0,0,0,0-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.5,33a11.45,11.45,0,0,1,2.09-6.59l-4.4,4.4a12.72,12.72,0,0,0,0,4.38l4.44,4.44A11.37,11.37,0,0,1,4.5,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.66,39.91a14,14,0,0,0-7.82-9.62,11.47,11.47,0,0,1,17.75-6.7l-4.4-4.4A14.38,14.38,0,0,0,50,19,14,14,0,0,0,36.48,29.45a13.68,13.68,0,0,0-7,0A14,14,0,0,0,16,19a14.38,14.38,0,0,0-2.19.19l-4.4,4.4a11.47,11.47,0,0,1,17.75,6.7,14,14,0,0,0-7.82,9.62,16.45,16.45,0,0,0-10.9,1.53l5.37,5.37A14.38,14.38,0,0,0,16,47a13.7,13.7,0,0,0,3.47-.45,14,14,0,0,0,27.06,0A13.7,13.7,0,0,0,50,47a14.38,14.38,0,0,0,2.19-.19l5.39-5.39A16.44,16.44,0,0,0,46.66,39.91ZM16,44.5a11.39,11.39,0,0,1-5.39-1.35A13.79,13.79,0,0,1,19,42.39c0,.2,0,.4,0,.61s0,.72.05,1.08A11.34,11.34,0,0,1,16,44.5Zm17,10a11.33,11.33,0,0,1-5.4-1.36,13.89,13.89,0,0,1,10.81,0A11.34,11.34,0,0,1,33,54.5Zm7.73-3a16.42,16.42,0,0,0-15.45,0,11.5,11.5,0,1,1,15.45,0ZM47,44.07c0-.35,0-.71,0-1.07s0-.42,0-.62a13.85,13.85,0,0,1,8.42.77A11.43,11.43,0,0,1,50,44.5,11,11,0,0,1,47,44.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,8.5a3.44,3.44,0,1,0,3.43,3.43A3.44,3.44,0,0,0,33,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.28.28a.4.4,0,0,0-.56,0L13.81,19.19A14.38,14.38,0,0,1,16,19,14,14,0,0,1,29.52,29.45a13.68,13.68,0,0,1,7,0A14,14,0,0,1,50,19a14.38,14.38,0,0,1,2.19.19Zm8.18,18.94-1.2,1.2a.39.39,0,0,1-.56,0l-3.5-3.5a5.87,5.87,0,0,1-3.2.95,6,6,0,1,1,5-2.71l3.49,3.49A.4.4,0,0,1,41.46,19.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,15.16a5.93,5.93,0,1,0-5,2.71,5.87,5.87,0,0,0,3.2-.95l3.5,3.5a.39.39,0,0,0,.56,0l1.2-1.2a.4.4,0,0,0,0-.57Zm-5,.21a3.44,3.44,0,1,1,3.43-3.44A3.44,3.44,0,0,1,33,15.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMSupervisores);
export default __webpack_public_path__ + "static/media/m_supervisores.8a39e5ac10e4e8b4d876149f257ae378.svg";
export { ForwardRef as ReactComponent };